import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalService } from 'src/app/services/global/global.service';

@Component({
  selector: 'app-more-course-info',
  templateUrl: './more-course-info.component.html',
  styleUrls: ['./more-course-info.component.scss']
})
export class MoreCourseInfoComponent {
  public courseData;
  public imageUrl = GlobalService.imageURL;
  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: any,) { }
  ngOnInit(): void {
    this.courseData = this.dialogData.data;
  }
  convertSecondsToHoursMinutesSeconds(seconds) {
    if (isNaN(seconds) || seconds < 0) {
      return "Invalid input";
    }

    const hours = Math.floor(seconds / 3600);
    const remainingMinutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    let result = "";

    if (hours > 0) {
      result += hours + (hours === 1 ? " hr" : " hr");
    }

    if (remainingMinutes > 0) {
      result += (result === "" ? "" : " ") + remainingMinutes + (remainingMinutes === 1 ? " min" : " min");
    }

    if (remainingSeconds > 0) {
      result += (result === "" ? "" : " ") + remainingSeconds + (remainingSeconds === 1 ? " sec" : " sec");
    }

    return result;
  }


  checkUrl(url: any) {

    let newUrl;
    if (url?.includes("https")) {
      newUrl = url;
    } else {
      newUrl = GlobalService.imageURL + url;
    }
    return newUrl;
  }
}
